import React, { useCallback, useEffect } from "react";
import { Helmet } from "react-helmet";
import '../designcss/tutorialcss.css';


const DownloadFiles38 = () => {
    const handleDownload = useCallback(() => {
        const files = [
            { href: 'https://gitlab.com/albiemerporte/myecommerceandportfolio2023/-/raw/v1/public/tutorial38/tutorial38.zip?ref_type=heads&inline=false', download: 'tutorial38.zip' }
        ];

        files.forEach(file => {
            const link = document.createElement('a');
            link.href = file.href;
            link.download = file.download;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }, []);

    return (
        <a href="#" onClick={handleDownload}>Download Repository</a>
    );
};

const TutorialThirtyEight= () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Add Adsterra script to head only on this page */}
            {/*<AdScripts />*/}

            <div className="blogcontainer" id="tutorial16">

                <div className="tutorial-banner" onClick={() => window.open("https://www.singlobby.com", "_blank")}>
                    <img src="https://res.cloudinary.com/dywqyzge2/image/upload/v1772299116/singlobby_banner_sokjnf.png" />
                </div>

                <div className="card">
                    <h2>How to Create a Camera Capture with Auto Save in QT Designer | Python3 and Pyqt6</h2>

                    <div className="fakeimg" style={{ height: "auto", width: "90%" }}>
                        <img 
                            src="https://img.youtube.com/vi/rG7FI_eHv9Y/maxresdefault.jpg"
                            alt="Tutorial 38"
                            style={{ maxWidth: "100%", height: "auto" }}
                        />
                    </div>

                    <p style={{ whiteSpace: "pre-wrap" }}>
                    In this PyQt6 tutorial, you’ll learn how to build a camera capture application with an automatic image-saving feature using Qt Designer, Python 3, and PyQt6. This step-by-step guide will show you how to design the GUI, integrate OpenCV for camera access, and automatically save captured images without additional user input.

                        <br /><strong>What You'll Learn:</strong>
                        <ul>
                            <li>Setting up PyQt6 and Qt Designer</li>
                            <li>Integrating OpenCV for real-time camera access</li>

                            <li>Designing a user-friendly interface with Qt Designer</li>

                            <li>Implementing automatic image capture and saving</li>
                        </ul>

                        By the end of this tutorial, you'll have a fully functional camera capture application capable of auto-saving images, perfect for both beginners and intermediate developers working on GUI-based projects.
                        <br /><br />
                        #PyQt6 #OpenCV #QtDesigner #Python3 #CameraCapture #AutoSave #GUI #PythonProgramming #ComputerVision

                    </p>

                    <button className="seemore">
                        <DownloadFiles38 />
                    </button>
                </div>
            </div><br />
        </>
    );
};

export default TutorialThirtyEight;
